const mainSVG = `
<?xml version="1.0" encoding="utf-8"?>
<!-- Generator: Adobe Illustrator 16.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 width="22.792px" height="16.422px" viewBox="0 0 22.792 16.422" enable-background="new 0 0 22.792 16.422" xml:space="preserve">
<g id="Layer_1">
	<g>
		<g>
			<path fill="#FFFFFF" stroke="#FFFFFF" stroke-width="0.75" stroke-miterlimit="10" d="M18.223,12.479
				c-0.088,0-0.176-0.031-0.245-0.098L13.89,8.545c-0.144-0.135-0.15-0.357-0.016-0.502c0.134-0.145,0.358-0.148,0.503-0.016
				l4.09,3.838c0.141,0.133,0.149,0.361,0.014,0.5C18.411,12.441,18.318,12.479,18.223,12.479z"/>
			<path fill="#FFFFFF" stroke="#FFFFFF" stroke-width="0.75" stroke-miterlimit="10" d="M4.57,12.479
				c-0.096,0-0.189-0.037-0.26-0.113c-0.135-0.139-0.127-0.367,0.016-0.5l4.092-3.838C8.561,7.896,8.786,7.898,8.92,8.043
				C9.055,8.188,9.047,8.41,8.904,8.545l-4.092,3.836C4.744,12.447,4.658,12.479,4.57,12.479z"/>
		</g>
		<path fill="#FFFFFF" stroke="#FFFFFF" stroke-width="0.75" stroke-miterlimit="10" d="M20.64,16.047H2.152
			c-0.979,0-1.777-0.797-1.777-1.777V2.152c0-0.98,0.798-1.777,1.777-1.777H20.64c0.98,0,1.777,0.797,1.777,1.777V14.27
			C22.417,15.25,21.62,16.047,20.64,16.047z M2.152,1.086c-0.588,0-1.067,0.479-1.067,1.066V14.27c0,0.588,0.479,1.064,1.067,1.064
			H20.64c0.588,0,1.067-0.477,1.067-1.064V2.152c0-0.588-0.479-1.066-1.067-1.066H2.152z"/>
		<path fill="#FFFFFF" stroke="#FFFFFF" stroke-width="0.75" stroke-miterlimit="10" d="M11.396,9.996
			c-0.473,0-0.945-0.156-1.305-0.471L0.965,1.564C0.816,1.438,0.801,1.211,0.93,1.063S1.283,0.9,1.431,1.029l9.128,7.959
			c0.453,0.396,1.221,0.396,1.675,0l9.116-7.947c0.146-0.129,0.371-0.115,0.502,0.035c0.126,0.15,0.111,0.371-0.035,0.5
			l-9.115,7.949C12.341,9.84,11.869,9.996,11.396,9.996z"/>
	</g>
</g>
<g id="LiveTXT" display="none">
</g>
<g id="GRids">
</g>
</svg>
`;

export default mainSVG;



// WEBPACK FOOTER //
// ./src/Components/inlineSVGs/mailSVG.js